import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default function DateField({ date, timezone, showTime }) {
  if (!date) {
    return null;
  }

  const momentObj = timezone ? moment(date).tz(timezone) : moment(date);

  return (
    (<div data-testid="div-d661e874" className="text-sm">
      <p data-testid="p-f54dd508" className="my-0">{momentObj.format('L')}</p>
      {showTime && <p data-testid="p-96218eae" className="my-0">{momentObj.format('LT')}</p>}
    </div>)
  );
}

DateField.propTypes = {
  showTime: PropTypes.bool,
};

DateField.defaultProps = {
  showTime: true,
};
